export default __webpack_public_path__ + "6a163de9e0b41cd6a9228512fe82f35b.png";